import { SchemaAnyPlugin } from '../Schema.Any'
import { SchemaArrayPlugin } from '../Schema.Array'
import { SchemaBigIntPlugin } from '../Schema.BigInt'
import { SchemaBooleanPlugin } from '../Schema.Boolean'
import { SchemaDatePlugin } from '../Schema.Date'
import { SchemaDateTimePlugin } from '../Schema.DateTime'
import { SchemaDynamicPlugin } from '../Schema.Dynamic'
import { SchemaFunctionPlugin } from '../Schema.Function'
import { SchemaIdentifierPlugin } from '../Schema.Identifier'
import { SchemaIntersectionPlugin } from '../Schema.Intersection'
import { SchemaMapPlugin } from '../Schema.Map'
import { SchemaNullPlugin } from '../Schema.Null'
import { SchemaNumberPlugin } from '../Schema.Number'
import { SchemaObjectPlugin } from '../Schema.Object'
import { SchemaReferencePlugin } from '../Schema.Reference'
import { SchemaSetPlugin } from '../Schema.Set'
import { SchemaStringPlugin } from '../Schema.String'
import { SchemaTypedSchemaPlugin } from '../Schema.TypedSchema'
import { SchemaUndefinedPlugin } from '../Schema.Undefined'
import { SchemaUnionPlugin } from '../Schema.Union'
import { SchemaUnknownPlugin } from '../Schema.Unknown'
import { SchemaURLSearchParamsPlugin } from '../Schema.URLSearchParams'
import { SchemaVoidPlugin } from '../Schema.Void'
import { SchemaDefinition } from './TypedDefinition'

import type { PluginVisitors, RehajePlugin } from '../../types'

export class SchemaPlugin implements RehajePlugin {
  plugins: RehajePlugin[] = [
    new SchemaAnyPlugin(),
    new SchemaArrayPlugin(),
    new SchemaBigIntPlugin(),
    new SchemaBooleanPlugin(),
    new SchemaDatePlugin(),
    new SchemaDateTimePlugin(),
    new SchemaDynamicPlugin(),
    new SchemaFunctionPlugin(),
    new SchemaIntersectionPlugin(),
    new SchemaMapPlugin(),
    new SchemaSetPlugin(),
    new SchemaURLSearchParamsPlugin(),
    new SchemaNullPlugin(),
    new SchemaNumberPlugin(),
    new SchemaObjectPlugin(),
    new SchemaReferencePlugin(),
    new SchemaStringPlugin(),
    new SchemaTypedSchemaPlugin(),
    new SchemaUndefinedPlugin(),
    new SchemaUnionPlugin(),
    new SchemaUnknownPlugin(),
    new SchemaVoidPlugin(),
    new SchemaIdentifierPlugin()
  ]

  visitors: PluginVisitors = {
    definitions: {
      Schema: SchemaDefinition
    }
  }
}
